export const GET_QUESTIONS_ANSWERS = 'GET_QUESTIONS_ANSWERS';
export const GET_QUESTIONS_ANSWERS_SUCCESS = 'GET_QUESTIONS_ANSWERS_SUCCESS';

export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';

export const SUBMIT_QUESTION_ANSWERS = 'SUBMIT_QUESTION_ANSWERS';
